var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "90.000000pt",
    height: "90.000000pt",
    viewBox: "0 0 90.000000 90.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,90.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328 572 c-260 -260 -257 -255 -218 -332 39 -76 135 -150 195 -150 36 0 505 470 505 506 0 59 -75 156 -150 194 -77 39 -72 42 -332 -218z m267 88 c0 -18 -6 -26 -23 -28 -24 -4 -38 18 -28 44 3 9 15 14 28 12 17 -2 23 -10 23 -28z m90 -90 c0 -18 -6 -26 -23 -28 -13 -2 -25 3 -28 12 -10 26 4 48 28 44 17 -2 23 -10 23 -28z m-162 -44 c37 -35 67 -68 67 -73 0 -4 -31 -40 -70 -78 l-70 -69 -70 69 c-38 38 -70 74 -70 78 0 11 130 137 140 137 4 0 37 -29 73 -64z m-258 -196 c0 -18 -6 -26 -23 -28 -13 -2 -25 3 -28 12 -10 26 4 48 28 44 17 -2 23 -10 23 -28z m90 -90 c0 -18 -6 -26 -23 -28 -13 -2 -25 3 -28 12 -10 26 4 48 28 44 17 -2 23 -10 23 -28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreat);
export default __webpack_public_path__ + "static/media/treat.d637c525f8d495c8a22f3220aa00c6a0.svg";
export { ForwardRef as ReactComponent };